// extracted by mini-css-extract-plugin
export default {"succes":"InfoBaner_succes__vxdhd","deny":"InfoBaner_deny__Ns4ny","Wrapper":"InfoBaner_Wrapper__oNnQ2","Wrapper__succes":"InfoBaner_Wrapper__succes__76gV5"};